<template>
    <div class="container-fluid pb-0">
        <div class="row">
            <div class="col-md-12">
                <div class="section height-auto">
                    <div class="player-info-wrapper ">
                        <div class="row">
                            <!-- PLayer Data -->
                            <div class="col-md-12 col-xl-4">
                                <div class="box-info-wrapper">
                                    <div class="logo-wrapper pr-4">
                                        <img class="player-icon" v-if="playerInfo.photo" :src="playerInfo.photo" alt="player photo">

                                        <CustomEmblem
                                          v-if="!playerInfo.photo"
                                          :gender="playerInfo.gender"
                                          :sub-header="[playerInfo.firstName, playerInfo.lastName]"
                                        />
                                    </div>
                                    <div class="info-wrapper w-100">
                                        <h2>{{playerInfo.firstName}} {{playerInfo.lastName}}</h2>
                                        <h5 class="data-name">{{ $t('SESSION_HISTORY.header.position')}}: {{playerInfo.position ? playerInfo.position : '/'}}</h5>
                                        <div class="player-info">
                                            <div class="row">
                                                <div class="col-4">
                                                    <h5 class="data-name">{{ $t('SESSION_HISTORY.header.maxHr')}}</h5>
                                                    <div class="player-info-data">
                                                        <span>{{playerInfo.maxHeartRate != null ? `${playerInfo.maxHeartRate} BPM` : $t('COMMON.notApplicable') }}</span>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                  <h5 class="data-name">{{ $t('SESSION_HISTORY.header.weight')}}</h5>
                                                  <div class="player-info-data">
                                                    <span>{{playerInfo.weight != null ? `${playerInfo.weight} KG` : $t('COMMON.notApplicable') }}</span>
                                                  </div>
                                                </div>
                                                <div class="col-4">
                                                    <h5 class="data-name">{{ $t('SESSION_HISTORY.header.height')}}</h5>
                                                    <div class="player-info-data">
                                                        <span>{{playerInfo.height != null ? `${playerInfo.height} CM` : $t('COMMON.notApplicable') }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Filter and Metrics -->
                            <div class="col-md-12 col-xl-8">
                                <div class="team-stats-info">
                                    <b-button-group class="switch-btn-group">
                                      <b-button class="button-stats active">{{ $t('SESSION_HISTORY.header.lastSession')}}</b-button>
                                      <b-button class="button-stats disabled">{{ $t('SESSION_HISTORY.header.last7days')}}</b-button>
                                      <b-button class="button-stats disabled">{{ $t('SESSION_HISTORY.header.lastMonth')}}</b-button>
                                    </b-button-group>

                                    <div class="row">
                                        <!-- Heart Rate -->
                                        <div class="col-3">
                                            <div class="header-stats">
                                                <div class="stats-icon-wrapper">
                                                    <img src="@/assets/images/activity/hr-icon.png" alt="hr">
                                                </div>
                                                <div class="stats-info">
                                                    <h5 class="data-name d-none d-md-block">{{ $t('SESSION_HISTORY.header.heartRate')}}</h5>
                                                    <p class="stats-value" v-if="playerInfo.hrAbove80PercentSeconds == null">{{$t('COMMON.notApplicable')}}</p>
                                                    <p class="stats-value" v-if="playerInfo.hrAbove80PercentSeconds != null">{{playerInfo.hrAbove80PercentSeconds | secondsToMinutes}} min</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Active Participation -->
                                        <div class="col-3">
                                            <div class="header-stats">
                                                <div class="stats-icon-wrapper">
                                                    <img src="@/assets/images/activity/active-participation-icon.png" alt="participation">
                                                </div>
                                                <div class="stats-info">
                                                    <h5 class="data-name d-none d-md-block">{{ $t('SESSION_HISTORY.header.activeParticipation')}}</h5>
                                                    <p class="stats-value">{{playerInfo.avgAP != null ? `${playerInfo.avgAP}%` : $t('COMMON.notApplicable') }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Workload -->
                                        <div class="col-3">
                                            <div class="header-stats">
                                                <div class="stats-icon-wrapper">
                                                    <img src="@/assets/images/activity/workload-icon.png" alt="workload">
                                                </div>
                                                <div class="stats-info">
                                                    <h5 class="data-name d-none d-md-block">{{ $t('SESSION_HISTORY.header.workload')}}</h5>
                                                    <p class="stats-value">{{playerInfo.workload != null ? `${Math.round(playerInfo.workload)}` : $t('COMMON.notApplicable') }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Distance -->
                                        <div class="col-3">
                                            <div class="header-stats">
                                                <div class="stats-icon-wrapper">
                                                    <img src="@/assets/images/activity/distance-speed-icon.png" alt="distance">
                                                </div>
                                                <div class="stats-info">
                                                    <h5 class="data-name d-none d-md-block">{{ $t('SESSION_HISTORY.header.distance')}}</h5>
                                                    <p class="stats-value">{{playerInfo.distance != null ? `${playerInfo.distance.toLocaleString()} m` : $t('COMMON.notApplicable') }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomEmblem from '@/components/common/CustomEmblem'

export default {
  name: 'SessionHistoryHeader',
  props: {
    playerInfo : Object,
    playerSessions : Array,
    account : Object
  },
  components: {
    CustomEmblem
  }
}
</script>

<style lang="scss" scoped>
    .height-auto{
        height: auto;
    }
    .player-info-wrapper {
        border-bottom: 1px solid $shark-gray;
        margin-bottom: 20px;

        .data-name  {
            font-size: 12px;
            margin-bottom: 3px;
        }

        .box-info-wrapper {
            display: flex;
            width: 100%;
            margin-bottom: 20px;
            border-right: 1px solid $shark-gray;
            .logo-wrapper {
                display: table;
                position: relative;
                img {
                    height: 70px;
                    width: 70px;
                }
            }
            .info-wrapper {

                h2 {
                font-size: 18px;
                }

                .player-info {
                    margin-top: 30px;
                    padding-right: 10px;
                    .stats-name {
                        font-size: 14px;
                    }
                    .player-info-data {
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        width: 100%;
                        font-size: 14px;
                    }
                }
            }
        }

        .btn-group {
            margin-top: 0;
            margin-bottom: 25px;
            border: 2px solid #1A1A1D;
            border-radius: 6px;

        }

        .header-stats {
            display: flex;
            font-size: 14px;

            .stats-icon-wrapper {
                padding: 15px;
            }

            .stats-info {
                padding-top: 15px;
            }
        }
    }

    @media (max-width: 1200px){
        .box-info-wrapper {
            border-right: none !important;
            border-bottom: 1px solid $shark-gray;
            padding-bottom: 20px;
        }
    }

    @media (max-width: 768px){
        .player-info-wrapper {
            .header-stats {
                display: block;
                text-align: center;
                .stats-icon-wrapper {
                    padding: 5px;
                }
            }
        }
    }

    @media (max-width: 480px){
        .box-info-wrapper {
            flex-direction: column;
            .info-wrapper {
                margin-top: 20px;
            }
        }
        .btn-group{
            .button-stats {
                padding: 0 15px !important;
            }
        }

    }
</style>
